import { Box, Flex } from '@volue/wave-react';
import React from 'react';

import type { Printable } from '@/features/execute-calculation-set/overmind/calculation/domain/Printable';
import type { EvaluatedResult } from '@/features/execute-calculation-set/overmind/calculation/evaluation/EvaluatedResult';

import { EvaluatedValue } from './MediumVoltageCalculation/LoadFlowSummaryCalculationResults/EvaluatedCalculationResult';

export const EvaluatedResultsRange = <T extends Printable>(props: {
  range: { min: EvaluatedResult<T>; max: EvaluatedResult<T> };
  label: string;
}) => {
  return (
    <Flex main={'space-between'}>
      <span>
        {props.label}
        {':'}
      </span>
      <Box>
        <EvaluatedValue
          value={props.range.min.value.toString()}
          status={props.range.min.status}
        />
        <Box className="dIB mHxs">{'-'}</Box>
        <EvaluatedValue
          value={props.range.max.value.toString()}
          status={props.range.max.status}
        />
      </Box>
    </Flex>
  );
};
